import React, { Component } from 'react';
import moment from 'moment';
import { Glyphicon } from 'react-bootstrap';

class UKEUipo extends Component {
  constructor() {
    super();
    this.state = {
      page: 1
    };
  }

  firstPage() {
    this.setState({page: 1});
  }

  lastPage() {
    this.setState({page: this.numofPages()});
  }

  nextPage() {
    if(this.state.page < this.numofPages()){
      this.setState((prevState) => {
        return {page: prevState.page + 1};
      });
    }
  }

  prevPage() {
    if(this.state.page > 1){
      this.setState((prevState) => {
        return {page: prevState.page - 1};
      });
    }
  }

  numofPages() {
    if(this.props.content[0].data){
      return Math.ceil((this.props.content[0].data.length / 10));
    } else {
      return 1;
    }
  }

  jumpToPage(page) {
    this.setState({page: page});
  }

  getInterval() {
    // (this.state.page-2), (this.state.page+2)
    if(this.numofPages() > 5) {
      if(this.state.page < 3) {
        return [0, 5];
      }
      else if(this.state.page > this.numofPages() - 2) {
        return [(this.numofPages() - 5), (this.numofPages())];
      }
      else {
        return [(this.state.page - 3), (this.state.page + 2)];
      }
    } else {
      return [0, (this.numofPages())];
    }


  }

  navigation() {
    return (
      <div className="trademarks-navigation">
        <div onClick={this.firstPage.bind(this)} className="trademarks-navigation-button"><Glyphicon glyph="glyphicon glyphicon-step-backward"/></div>
        <div onClick={this.prevPage.bind(this)} className="trademarks-navigation-button"><Glyphicon glyph="glyphicon glyphicon-triangle-left"/></div>
        {Array.from({length: this.numofPages()}, (v, k) => k+1).slice(this.getInterval()[0], this.getInterval()[1]).map((page) =>
          <div onClick={this.jumpToPage.bind(this, page)}
          key={page}
          className={this.state.page === page ? "navigation__page-number navigation-current-page-number" : "navigation__page-number"}>{page}</div>
        )}
        <div onClick={this.nextPage.bind(this)} className="trademarks-navigation-button"><Glyphicon glyph="glyphicon glyphicon-triangle-right"/></div>
        <div onClick={this.lastPage.bind(this)} className="trademarks-navigation-button"><Glyphicon glyph="glyphicon glyphicon-step-forward"/></div>
      </div>
    );
  }

  results() {
    if(this.props.content[0].data){
      const min = 0 + (10 * (this.state.page - 1));
      const max = (min + 10) <= this.props.content[0].data.length
                  ? (min + 10)
                  : (this.props.content[0].data.length);
      return this.props.content[0].data.slice(min, max);
    }
  }


  render() {
    if (Object.keys(this.props.content).length !== 0) {
      let results;
      if (this.props.content[0].status === 'ok') {
        results =
          <div>
          <table className="trademarks-table">
            <tbody>
              <tr>
                <th>Trade mark text</th>
                <th className='trademark-table-status-th'>Status</th>
                <th className='trademark-table-filed-th'>Filing Date</th>
              </tr>
              {this.results().map((item,i) =>
                <tr key={i}>
                  <td>
                    <a href={item.link} target="_blank" rel="noopener noreferrer">
                      {item.marktext}
                    </a>
                  </td>
                  <td className="trademark-td">{item.status}</td>
                  <td className="trademark-td">{moment(item.filed).format('ll')}</td>
                </tr>
              )}
            </tbody>
          </table>
          </div>;
      } else if (this.props.content[0].status === 'none') {
        results = <div className="trademarks-status-message">{"Your search didn't return any similar trade marks."}</div>;
      } else {
        results = <div className="trademarks-status-message">Something went wrong. Please try again later.</div>;
      }

      return (
        <div>
          <div className="trademarks-count">
            <span>{this.props.content[0].data.length + ' similar trade marks found.'}</span>
          </div>

          <div className="ResultBox--trademarks prh">
            {results}
          </div>
          {this.navigation()}
        </div>
      );
    } else {
      return (
        <div className="ResultBox--trademarks prh">
          <p>Loading...</p>
        </div>
      );
    }
  }
}

export default UKEUipo;



// WEBPACK FOOTER //
// ./client/src/Engines/UKEUipo.js